import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet-async";
import validator from "validator";
import { useStateContext } from '../components/contexts/ContextProvider';
import LoadContentSpinner from '../components/Utils/LoadContentSpinner';
import axiosClient from '../components/api/axiosClient';
import QrCodeSection from '../components/QrCodeSection';

export default function ContactPage() {
    // useEffect(() => {
    //     // Mettre à jour le titre de la page
    //     document.title = "Contactez-nous - Events";
        
    // }, []);

    //   Contact form
    const [errors, setErrors] = useState({});
    const [formValue, setFormValue] = useState({nom: '', objet: '', email: '', message: ''});
    const [isSubmit, setIsSubmit] = useState(false);
    const [setLoadingBtn, setLoadingBtnsetLoadingBtn] = useState(false);
    const [validationError, setValidationError] = useState();
    const [successMessage, setSuccessMessage] = useState();
    const { setLoading } = useStateContext();

    const handleValidation = (e) => {
        const {name, value} = e.target;
        setFormValue({...formValue, [name]: value});
    }

    // Créez une fonction pour réinitialiser les états du formulaire
    const resetForm = () => {
        setFormValue({ nom: '', objet: '', email: '', message: '' }); // Réinitialise les valeurs des champs à vide
        setErrors({}); // Efface les éventuelles erreurs de validation
        setIsSubmit(false); // Réinitialise l'état de soumission à false
    };

    const validateForm = (value) => {
        const newErrors = {};

        // Validation du champ nom
        const trimmedNom = value.nom.trim();
        if (!trimmedNom) {
            newErrors.nom = "Ce champ est requis";
        } else if (!validator.isLength(trimmedNom, { min: 3 })) {
            newErrors.nom = "Le nom complet doit contenir au moins 3 caractères";
        } else if (!/^[a-zA-Z\sÀ-ÿ'-]+$/.test(trimmedNom)) {
            newErrors.nom = "Le nom complet ne doit contenir que des lettres";
        }

        // Validation du champ objet
        const trimmedObjet = value.objet.trim();
        if (!trimmedObjet) {
            newErrors.objet = "Ce champ est requis";
        } else if (!validator.isLength(trimmedObjet, { min: 10 })) {
            newErrors.objet = "Veuillez rédiger correctement votre objet de contact";
        }

        // Validation du champ email
        const trimmedEmail = value.email.trim();
        if (!trimmedEmail) {
            newErrors.email = "L'e-mail est requis";
        } else if (!validator.isEmail(trimmedEmail)) {
            newErrors.email = "L'adresse e-mail n'est pas valide";
        }

        // Validation du champ message
        const trimmedMessage = value.message.trim();
        if (!trimmedMessage) {
            newErrors.message = "Ce champ est requis";
        } else if (!validator.isLength(trimmedMessage, { min: 15 })) {
            newErrors.message = "Veuillez rédiger correctement votre préoccupation";
        }

        return newErrors;
    };
    
    useEffect(() => {
        // Si le formulaire est soumis et qu'il n'y a pas d'erreurs, effectuez une action
        if (Object.keys(errors).length === 0 && isSubmit) {
            // console.log(formValue);
        }
    }, [errors, formValue, isSubmit]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Valider le formulaire avant de passer à l'étape suivante
        const formErrors = validateForm(formValue);

        // Vérifier si le formulaire est valide
        if (Object.keys(formErrors).length === 0) {
            setLoadingBtnsetLoadingBtn(true); // Activer le chargement
            
            try {
                axiosClient.post('/request/eventsApp/sendContactToUsersInterface/get-datas-to-user33-5452e-e873', formValue )
                .then((response) => {
                    // Mise à jour du statut selon la réponse du serveur
                    setSuccessMessage(response.data.messages);
        
                    setLoadingBtnsetLoadingBtn(false);
                    resetForm(); // Réinitialise le formulaire
                    // Fermer le message
                    setTimeout(() => setSuccessMessage(""), 3000);
                })
                .catch(function (error) {
                    if (error.response) {
                        if (error.response.status === 422) {
                            // Mise à jour du statut en cas d'erreur de validation
                            setValidationError(
                                "Erreur ! Veuillez vérifier vos informations puis réessayer s'il vous plait !"
                            );
                            setLoadingBtnsetLoadingBtn(false);
                            // Fermer le message
                            setTimeout(() => setValidationError(""), 3000);
                        }else if (error.response.status === 500) {
                            setValidationError(error.response.data.errors);
                            setLoadingBtnsetLoadingBtn(false);

                            // Fermer le message
                            setTimeout(() => setValidationError(""), 3000);
                        } else {
                            setValidationError(
                                "OUPS ! Une erreur est survenu, Veuillez réessayer ulterieurement."
                            );
                            setLoadingBtnsetLoadingBtn(false);
                            setTimeout(() => setValidationError(""), 3000);
                        }
                    } else{

                        setValidationError(
                            "OUPS ! Une erreur est survenu, Veuillez réessayer ulterieurement."
                        );
                        setLoadingBtnsetLoadingBtn(false);
                        setTimeout(() => setValidationError(""), 3000);
                    }
                });
            } catch (err) {
                setValidationError("Erreur de traitement ! Veuillez réessayer s'il vous plait !");
                setLoadingBtnsetLoadingBtn(false);
                // Fermer le message
                setTimeout(() => setValidationError(""), 3000);
            }
        }

        // Mettre à jour les erreurs après la validation
        setErrors(formErrors);
        
        // Définir isSubmit à true pour activer useEffect
        setIsSubmit(true);
    };

    if (setLoading) {
        return <LoadContentSpinner />;
    }

    const quickContactCards = [
        {
            title: "WhatsApp (recommandé)",
            description: "Discutez instantanément avec un conseiller pour une réponse rapide.",
            href: "https://wa.me/2250717519518",
            cta: "Parler sur WhatsApp",
            icon: "lab la-whatsapp",
            highlight: true,
        },
        {
            title: "Appeler un conseiller",
            description: "Besoin d'une assistance immédiate ? Contactez-nous par téléphone.",
            href: "tel:+2250717519518",
            cta: "Appeler maintenant",
            icon: "las la-phone-volume",
        },
        {
            title: "Envoyer un formulaire",
            description: "Décrivez votre demande en détail, nous revenons vers vous rapidement.",
            href: "#contact-form",
            cta: "Remplir le formulaire",
            icon: "las la-paper-plane",
        },
    ];

    const socialLinks = [
        {
            title: "Facebook",
            href: "https://www.facebook.com/profile.php?id=61558762937775",
            icon: "lab la-facebook-square",
            color: "text-blue-500",
        },
        {
            title: "Instagram",
            href: "https://www.instagram.com/events_billetterie?igsh=YzljYTk1ODg3Zg==",
            icon: "lab la-instagram",
            color: "text-pink-500",
        },
        {
            title: "Youtube",
            href: "https://www.youtube.com/@Eventsbilletterie",
            icon: "lab la-youtube",
            color: "text-red-500",
        },
        {
            title: "WhatsApp",
            href: "https://wa.me/2250717519518",
            icon: "lab la-whatsapp",
            color: "text-green-500",
        },
    ];

    const canonicalUrl = "https://eventsbilletterie.com/nous-contacter";
    const seoTitle = "Contact Events billetterie | WhatsApp, telephone et formulaire";
    const seoDescription =
        "Contactez Events billetterie rapidement via WhatsApp, telephone ou formulaire. Assistance billetterie evenementielle en Cote d'Ivoire pour organisateurs et participants.";
    const seoKeywords =
        "contact events billetterie, support billetterie, whatsapp billetterie, assistance evenement cote d'ivoire, service client events billetterie, contacter organisateur evenement billetterie, billetterie en ligne cote d'ivoire, vente de tickets evenement, gestion inscriptions, controle d'acces qr code, billets physiques evenement, bracelets unique, bracelets securises, ticket unique, ticket unique cote d'ivoire, ticket securise, ticket infalsifiable, ticket qr code, bracelet qr code, qr code unique";
    const seoImage = "https://eventsbilletterie.com/assets/images/facadeEvents.png";
    const contactSeoJsonLd = {
        "@context": "https://schema.org",
        "@type": "ContactPage",
        name: seoTitle,
        description: seoDescription,
        url: canonicalUrl,
        inLanguage: "fr-CI",
        mainEntity: {
            "@type": "Organization",
            name: "Events Billetterie",
            url: "https://eventsbilletterie.com",
            contactPoint: [
                {
                    "@type": "ContactPoint",
                    contactType: "customer support",
                    telephone: "+2250717519518",
                    email: "support@eventsbilletterie.com",
                    areaServed: "CI",
                    availableLanguage: ["fr"],
                },
                {
                    "@type": "ContactPoint",
                    contactType: "sales",
                    telephone: "+2250717519518",
                    email: "contact@eventsbilletterie.com",
                    areaServed: "CI",
                    availableLanguage: ["fr"],
                },
            ],
            address: {
                "@type": "PostalAddress",
                streetAddress: "Angre 8ieme Tranche, Cocody",
                addressLocality: "Abidjan",
                addressCountry: "CI",
            },
        },
    };

    return (
        <>
            <div className='z-5 relative'>
                <Helmet>
                    <html lang="fr" />
                    <title>{seoTitle}</title>
                    <meta name="description" content={seoDescription} />
                    <meta name="keywords" content={seoKeywords} />
                    <meta
                        name="robots"
                        content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
                    />
                    <meta name="author" content="Events" />
                    <meta property="og:type" content="website" />
                    <meta property="og:locale" content="fr_CI" />
                    <meta property="og:site_name" content="Events Billetterie" />
                    <meta property="og:title" content={seoTitle} />
                    <meta property="og:description" content={seoDescription} />
                    <meta property="og:image" content={seoImage} />
                    <meta property="og:url" content={canonicalUrl} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={seoTitle} />
                    <meta name="twitter:description" content={seoDescription} />
                    <meta name="twitter:image" content={seoImage} />
                    <meta name="twitter:site" content="@events_billetterie" />
                    <link rel="canonical" href={canonicalUrl} />
                    <script type="application/ld+json">
                        {JSON.stringify(contactSeoJsonLd)}
                    </script>
                </Helmet>
                
                <div className="glow-container">
                    <div className="ball"></div>
                    <div className="ball"></div>
                    <div className="ball"></div>

                </div>
                <div className="mb-10 lg:mb-2 z-5 relative">
                    <div className="container max-w-7xl mx-auto pt-12 px-4 sm:px-6">
                        <section className="text-center max-w-4xl mx-auto">
                            <span className="inline-flex items-center rounded-full bg-green-100 text-green-700 px-3 py-1 text-xs font-semibold mb-4">
                                Assistance Events
                            </span>
                            <h1 className="text-3xl md:text-4xl font-semibold text-gray-900 dark:text-gray-50">
                                Parlons de votre besoin
                            </h1>
                            <p className="mt-3 text-gray-700 dark:text-gray-400 text-base md:text-lg">
                                Contactez notre équipe via WhatsApp, par téléphone, via nos réseaux sociaux ou laissez-nous un message avec le formulaire.
                            </p>
                            {/* <p className="mt-2 text-sm text-gray-600 dark:text-neutral-400 font-semibold">
                                +225 07 17 51 95 18
                                <span className="font-normal"> - Abidjan, Côte d'Ivoire</span>
                            </p> */}
                        </section>

                        <section className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                            {quickContactCards.map((card) => (
                                <a
                                    key={card.title}
                                    href={card.href}
                                    target={card.href.startsWith("http") ? "_blank" : undefined}
                                    rel={card.href.startsWith("http") ? "noopener noreferrer" : undefined}
                                    className={`rounded-2xl border p-5 transition-all group ${
                                        card.highlight
                                            ? "border-green-300 bg-green-50 hover:shadow-lg"
                                            : "border-gray-100 bg-white hover:shadow-md dark:bg-neutral-900 dark:border-neutral-800"
                                    }`}
                                >
                                    <div className="flex items-start justify-between gap-4">
                                        <div>
                                            <h2 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100">
                                                {card.title}
                                            </h2>
                                            <p className="mt-2 text-sm text-gray-600 dark:text-neutral-400">
                                                {card.description}
                                            </p>
                                        </div>
                                        <i className={`${card.icon} text-2xl text-neutral-700 dark:text-neutral-300`} />
                                    </div>
                                    <span className="mt-4 inline-flex items-center text-sm font-semibold text-primary-6000 group-hover:translate-x-1 transition-transform">
                                        {card.cta}
                                        <i className="las la-arrow-right ml-1" />
                                    </span>
                                </a>
                            ))}
                        </section>

                        <section className="mt-8 flex justify-center">
                            <nav className="flex items-center gap-4 rounded-full px-5 py-3 border border-gray-200 bg-white dark:bg-neutral-900 dark:border-neutral-700">
                                <span className="text-sm font-medium text-gray-600 dark:text-neutral-300">
                                    Suivez-nous sur nos reseaux
                                </span>
                                {socialLinks.map((social) => (
                                    <a
                                        key={social.title}
                                        className={`text-2xl ${social.color} hover:text-primary-6000 transition-colors`}
                                        href={social.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title={social.title}
                                    >
                                        <i className={social.icon} />
                                    </a>
                                ))}
                            </nav>
                        </section>

                        <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-2 mt-12 sm:mx-0">
                            <aside className="rounded-2xl border border-gray-100 bg-white dark:bg-neutral-900 dark:border-neutral-800 p-6 shadow-sm">
                                <h2 className="text-2xl font-semibold text-neutral-900 dark:text-neutral-100">
                                    Autres points de contact
                                </h2>
                                <p className="mt-2 text-sm text-gray-600 dark:text-neutral-400">
                                    Choisissez l'adresse la plus adaptee a votre demande.
                                </p>
                                <div className="mt-5 grid gap-4">
                                    <article className="rounded-xl border border-gray-100 dark:border-neutral-800 p-4">
                                        
                                        <p className="mt-2 text-sm text-gray-600 dark:text-neutral-400">
                                            <i className="las la-map-marker-alt mr-2 text-gray-600" />
                                            Angre 8ieme Tranche, Cocody, Abidjan, Cote d'Ivoire
                                            <a
                                                href="https://www.google.com/maps/search/?api=1&query=Angré+8ième+Tranche,+Cocody,+Abidjan,+Côte+d'Ivoire"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="mt-3 ml-2 inline-flex items-center text-xs font-semibold text-blue-600 hover:underline"
                                            >
                                                Voir la Maps
                                                <i className="las la-external-link-alt ml-1" />
                                            </a>
                                        </p>
                                        <p className="mt-2 text-sm text-gray-600 dark:text-neutral-400">
                                            <i className="las la-phone-volume mr-2 text-gray-600" />
                                            (+225) 07 17 51 9518
                                        </p>
                                    </article>

                                </div>
                                <div className="mt-5 space-y-4">
                                    <a
                                        href="mailto:contact@eventsbilletterie.com"
                                        className="block rounded-xl border border-gray-100 dark:border-neutral-800 p-4 hover:border-primary-300 transition-colors"
                                    >
                                        <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">
                                            contact@eventsbilletterie.com
                                        </p>
                                        <p className="text-sm mt-1 text-gray-600 dark:text-neutral-400">
                                            Demandes generales, informations et partenariats.
                                        </p>
                                    </a>
                                    <a
                                        href="mailto:support@eventsbilletterie.com"
                                        className="block rounded-xl border border-gray-100 dark:border-neutral-800 p-4 hover:border-primary-300 transition-colors"
                                    >
                                        <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">
                                            support@eventsbilletterie.com
                                        </p>
                                        <p className="text-sm mt-1 text-gray-600 dark:text-neutral-400">
                                            Assistance technique et resolution des incidents.
                                        </p>
                                    </a>
                                    <a
                                        href="mailto:support.organizers@eventsbilletterie.com"
                                        className="block rounded-xl border border-gray-100 dark:border-neutral-800 p-4 hover:border-primary-300 transition-colors"
                                    >
                                        <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100">
                                            support.organizers@eventsbilletterie.com
                                        </p>
                                        <p className="text-sm mt-1 text-gray-600 dark:text-neutral-400">
                                            Accompagnement dedie aux organisateurs d'evenements.
                                        </p>
                                    </a>

                                </div>
                            </aside>

                            <div id="contact-form" className='shadow-md p-5 border border-gray-100 rounded-2xl w-full bg-white dark:bg-neutral-900 dark:border-neutral-800'>
                                <h2 className="text-xl font-semibold">Informations de contact</h2>
                                <div className="w-14 mb-4 mt-2 border-b border-neutral-200 dark:border-neutral-700" />
                                <form className="grid grid-cols-1 gap-6" onSubmit={handleSubmit}>
                                    <label className="block">
                                        <label className="nc-Label text-sm font-medium text-gray-700 dark:text-neutral-300 ">
                                        Votre nom complet
                                        <span className="text-red-600"> *</span>
                                        </label>
                                        <input 
                                        className="block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 rounded-2xl text-sm font-normal h-11 px-4 py-3 mt-1"
                                        placeholder="Exemple: Elysee ALLA"
                                        type="text"
                                        onChange={handleValidation}
                                        required
                                        name="nom"
                                        value={formValue.nom}
                                        />
                                        {errors.nom && (
                                        <small className="text-red-600 mt-2">
                                            {errors.nom}
                                        </small>
                                        )}
                                    </label>
                                    <label className="block">
                                        <label className="nc-Label text-sm font-medium text-neutral-700 dark:text-neutral-300 ">
                                        Objet du mail
                                        <span className="text-red-600"> *</span>
                                        </label>
                                        <input 
                                        className="block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 rounded-2xl text-sm font-normal h-11 px-4 py-3 mt-1"
                                        placeholder="Entrez un objet de contact"
                                        type="text"
                                        onChange={handleValidation}
                                        required
                                        name="objet"
                                        value={formValue.objet}
                                        />
                                        {errors.objet && (
                                        <small className="text-red-600 mt-2">
                                            {errors.objet}
                                        </small>
                                        )}
                                    </label>
                                    <label className="block">
                                        <label className="nc-Label text-sm font-medium text-gray-700 dark:text-neutral-300 ">
                                        Adresse E-mail
                                        <span className="text-red-600"> *</span>
                                        </label>
                                        <input
                                        className="block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 rounded-2xl text-sm font-normal h-11 px-4 py-3 mt-1"
                                        placeholder="example@example.com"
                                        type="email"
                                        onChange={handleValidation}
                                        required
                                        name="email"
                                        value={formValue.email}
                                        />
                                        {errors.email && (
                                            <small className="text-red-600 mt-2">
                                                {errors.email}
                                            </small>
                                        )}
                                    </label>
                                    <label className="block">
                                        <label className="nc-Label text-sm font-medium text-gray-700 dark:text-neutral-300 ">
                                            Message
                                            <span className="text-red-600"> *</span>
                                        </label>
                                        <textarea
                                        className="block w-full text-sm rounded-2xl border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50 bg-white dark:border-neutral-700 dark:focus:ring-primary-6000 dark:focus:ring-opacity-25 dark:bg-neutral-900 mt-1"
                                        rows={6}
                                        placeholder='Entrez le contenu de votre message'
                                        onChange={handleValidation}
                                        required
                                        name="message"
                                        value={formValue.message}
                                        />
                                        {errors.message && (
                                        <small className="text-red-600 mt-2">
                                            {errors.message}
                                        </small>
                                        )}
                                    </label>
                                    <div>
                                    <button
                                        className={`nc-Button relative h-auto inline-flex items-center justify-center rounded-lg transition-colors text-sm sm:text-base font-medium px-4 py-2 sm:px-6 ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-white ${setLoadingBtn ? 'pointer-events-none opacity-50' : ''}`}
                                        type="submit"
                                    >
                                        {setLoadingBtn ? (
                                            <>
                                                <svg
                                                    className="animate-spin mr-3 h-5 w-5 ml-3"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <circle
                                                        className="opacity-25"
                                                        cx={12}
                                                        cy={12}
                                                        r={10}
                                                        stroke="currentColor"
                                                        strokeWidth={3}
                                                    />
                                                    <path
                                                        className="opacity-75"
                                                        fill="currentColor"
                                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                                    />
                                                </svg>
                                                Envoi en cours...
                                            </>
                                        ) : (
                                            <>
                                                Envoyer 
                                                <i className="las la-paper-plane ml-2"></i>
                                            </>
                                        )}
                                    </button>
                                    </div>
                                </form>

                                
                                {successMessage && (
                                    <div
                                        className="px-2.5 py-1 mt-3 flex nc-Badge rounded-full font-medium text-xs text-green-800 bg-green-100"
                                        style={{width: "fit-content"}}
                                    >
                                        <span>
                                            <svg
                                            viewBox="0 0 24 24"
                                            width={20}
                                            height={20}
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="me-2"
                                            >
                                            <polyline points="9 11 12 14 22 4" />
                                            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                                            </svg>
                                        </span>
                                        <span className="text-sm ml-3 mr-3">{successMessage}</span>
                                    </div>
                                )}
                                {validationError && (
                                    <div
                                        className="px-2.5 py-1 p-3 mt-3 flex nc-Badge rounded-full font-medium text-xs text-red-800 bg-red-100"
                                        style={{width: "fit-content"}}
                                    >
                                        <span>
                                            <svg
                                            viewBox="0 0 24 24"
                                            width={20}
                                            height={20}
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            fill="none"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="me-2"
                                            >
                                            <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2" />
                                            <line x1={15} y1={9} x2={9} y2={15} />
                                            <line x1={9} y1={9} x2={15} y2={15} />
                                            </svg>
                                        </span>
                                        <span className="text-sm ml-3 mr-3">{validationError}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            <QrCodeSection />
        </>
    )
}
